import { render, staticRenderFns } from "./ClientResume.vue?vue&type=template&id=44714cf6&scoped=true&lang=html"
import script from "./ClientResume.vue?vue&type=script&lang=js"
export * from "./ClientResume.vue?vue&type=script&lang=js"
import style0 from "./ClientResume.vue?vue&type=style&index=0&id=44714cf6&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44714cf6",
  null
  
)

export default component.exports